import { apiPaths } from './kepala-sekolah/config'
import { useQueryApi } from 'utils/api'

import type { CommonResponse } from 'types/api'
import type { UQO } from 'types/kinerja-dinas-penilaian'

export type TRequestStatusPengaliranSkp = {
  year: number
  jabatan: 'guru' | 'ks'
}

type TResponseStatusPengaliranSkp = CommonResponse<{
  asn: boolean
  pengaliran:
    | undefined // Can be either undefined or an empty object if the user is not ASN
    | {} // Can be either undefined or an empty object if the user is not ASN
    | {
        synced: boolean
        lastSync: string // eg. "2024-10-15T07:08:37.499Z"
      }
}>

const API_GET_STATUS_PENGALIRAN_SKP = 'API_GET_STATUS_PENGALIRAN_SKP'

export function useApiGetPengaliranSkpStatus(
  params: TRequestStatusPengaliranSkp,
  opts?: UQO<TResponseStatusPengaliranSkp>
) {
  const skpYear = params?.year || undefined
  const jabatan = params?.jabatan || undefined

  return useQueryApi<TResponseStatusPengaliranSkp>(
    `${apiPaths.ekin}/pengaliran/skp/status`,
    {
      axiosConfig: { params: { skp_year: skpYear, jabatan } },
      queryConfig: { useErrorBoundary: false, ...opts },
      queryKey: [API_GET_STATUS_PENGALIRAN_SKP, skpYear, jabatan],
    }
  )
}
